import {
  Map,
  View
} from 'ol'
import TileLayer from 'ol/layer/Tile'
import {
  get as getProjection,
  Projection,
  transformExtent
} from 'ol/proj.js'
import {
  getTopLeft,
  getWidth
} from 'ol/extent'
import TileGrid from 'ol/tilegrid/TileGrid'
import TileImage from 'ol/source/TileImage'
import {
  defaults as Defaultscontrol
} from 'ol/control'
import ScaleLine from 'ol/control/ScaleLine'
import MousePosition from 'ol/control/MousePosition'
import {
  createStringXY as CreateStringXY
} from 'ol/coordinate'
import WKT from 'ol/format/WKT'
import Vector from 'ol/source/Vector'
import LayerVector from 'ol/layer/Vector'
import Style from 'ol/style/Style'
// import Icon from "ol/style/Icon";
import Text from 'ol/style/Text'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'
import Circle from 'ol/style/Circle'
import Polygon from 'ol/geom/Polygon'
import Draw from 'ol/interaction/Draw'
import XYZ from 'ol/source/XYZ'
import ImageStatic from 'ol/source/ImageStatic'
import Layer from 'ol/layer/Image'
import {
  easeOut
} from 'ol/easing'
// eslint-disable-next-line no-unused-vars
import Observable, {
  unByKey
} from 'ol/Observable'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import context from '../../main.js'
import geoblaze from 'geoblaze'
import store from '../../vuex/index'
// import Modify from 'ol/interaction/Modify'
var Mapobj = ''
var projection = new Projection({
  code: 'EPSG:4326',
  units: 'degrees'
})
// 地图底图切换
var tdtLayers = {
  vec_c: getTdtLayer('vec_c'),
  cva_c: getTdtLayer('cva_c'),
  img_c: getTdtLayer('img_c'),
  cia_c: getTdtLayer('cia_c'),
  ter_c: getTdtLayer('ter_c'),
  cta_c: getTdtLayer('cta_c')
}
// 配置地图参数
function getTdtLayer (lyr) {
  var url = 'http://t0.tianditu.gov.cn/DataServer?T=' + lyr + '&X={x}&Y={y}&L={z}&tk=d270fd850bd9871ade59a1580f7ba089' // 在线
  var projection = getProjection('EPSG:4326')
  var projectionExtent = [-180, -90, 180, 90]
  var maxResolution = (getWidth(projectionExtent) / (256 * 2))
  var resolutions = new Array(16)
  var z
  for (z = 0; z < 16; ++z) {
    resolutions[z] = maxResolution / Math.pow(2, z)
  }
  var tileOrigin = getTopLeft(projectionExtent)
  var layer = new TileLayer({
    // extent: [-180, -90, 180, 90],
    source: new TileImage({
      tileUrlFunction: function (tileCoord) {
        var z = tileCoord[0] + 1
        var x = tileCoord[1]
        var y = -tileCoord[2] - 1
        var n = Math.pow(2, z + 1)
        x = x % n
        if (x * n < 0) {
          x = x + n
        }
        return url.replace('{z}', z.toString())
          .replace('{y}', y.toString())
          .replace('{x}', x.toString())
      },
      projection: projection,
      tileGrid: new TileGrid({
        origin: tileOrigin,
        resolutions: resolutions,
        tileSize: 256
      })
    })
  })
  return layer
}
// 地图中心点设置
var iniMapCenter = {
  x: 105,
  y: 34
}
// 比例尺
var scaleLineControl = new ScaleLine()
// mouseposition 方法
var mousePositionControl = new MousePosition({
  coordinateFormat: CreateStringXY(4),
  projection: 'EPSG:4326',
  // comment the following two lines to have the mouse position
  // be placed within the map.
  className: 'custom-mouse-position',
  target: document.getElementById('mouse-position'),
  undefinedHTML: '&nbsp;'
})
// 地图view参数配置
var mapView = new View({
  projection: projection,
  center: [iniMapCenter.x, iniMapCenter.y],
  zoom: 4,
  minZoom: 4,
  maxZoom: 15,
  extent: [73, 2, 137, 55]
})
// })
var mapZoom = 4
mapView.fit([17, -2, 130, 60], {
  nearest: true
})
// mapView.fit([73, 2, 130, 60], {
//   nearest: true
// })
// 设置首页map参数
function getmap () {
  var map = new Map({
    controls: Defaultscontrol({
      attributionOptions: ({
        collapsible: false
      })
    }).extend([
      scaleLineControl, mousePositionControl
    ]),
    target: 'map',
    layers: [tdtLayers.vec_c, tdtLayers.cva_c, tdtLayers.img_c, tdtLayers.cia_c, tdtLayers.ter_c, tdtLayers.cta_c],
    view: mapView
  })
  Mapobj = map
  // var view = map.getView()
  // view.setZoom(4)
  // view.setCenter([105, 34])
  return map
}

function changeMapCenter (map) {
  map.getView().setCenter([iniMapCenter.x, iniMapCenter.y])
  map.getView().fit([17, -2, 130, 60], {
    nearest: true
  })
  map.getView().setZoom(4)
  return map
}

function SwitchLayer (layerType) {
  tdtLayers.vec_c.setVisible(false)
  tdtLayers.cva_c.setVisible(false)
  tdtLayers.img_c.setVisible(false)
  tdtLayers.cia_c.setVisible(false)
  tdtLayers.ter_c.setVisible(false)
  tdtLayers.cta_c.setVisible(false)
  tdtLayers.cva_c.setZIndex(999)
  tdtLayers.cia_c.setZIndex(998)
  tdtLayers.cta_c.setZIndex(997)
  switch (layerType) {
    case 'vec_c':
      tdtLayers.vec_c.setVisible(true)
      tdtLayers.cva_c.setVisible(true)
      break
    case 'img_c':
      tdtLayers.img_c.setVisible(true)
      tdtLayers.cia_c.setVisible(true)
      break
    case 'ter_c':
      tdtLayers.ter_c.setVisible(true)
      tdtLayers.cta_c.setVisible(true)
      break
  }
}
// 矢量图层
var overSource = new Vector()
var overVector = new LayerVector({
  source: overSource,
  style: new Style({
    fill: new Fill({
      color: 'rgba(100,100,100,0.2)'
    }),
    stroke: new Stroke({
      color: '#d74a4a',
      width: 2
    }),
    image: new Circle({
      radius: 7,
      fill: new Fill({
        color: '#ffcc33'
      })
    })
  })
})
// 绘图绘制几何区域获取面积方法
function updateArea (currentArea) {
  console.log('已选面积:' + currentArea.toFixed(6))
  document.getElementById('footarea').innerHTML = '已选面积：' + currentArea.toFixed(6)
}
// 产品重新选择方法及清空方法
function productReselution () {
  var it = document.getElementById('gundong').firstChild
  if (it != null) {
    var resel = it.getAttribute('resolution')
    return resel === 'null' ? null : resel
  } else {
    return null
  }
}

function areaIsFit (extent, res) {
  var width = extent[2] - extent[0]
  var height = extent[3] - extent[1]
  if (width < res) {
    context.$message({
      message: '所选区域宽度小于该产品单位像元宽度,请重新绘制',
      type: 'warning'
    })
    return false
  } else if (height < res) {
    context.$message({
      message: '所选区域高度小于该产品单位像元高度,请重新绘制',
      type: 'warning'
    })
    return false
  } else {
    return true
  }
}

function subAddWKT2Source (geowkt, isZoomTo) {
  var format = new WKT()
  var feature = format.readFeature(geowkt, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:4326'
  })
  overSource.clear()
  overSource.addFeature(feature)
  updateArea(feature.getGeometry().getArea())
  if (isZoomTo) {
    Mapobj.getView().fit(feature.getGeometry().getExtent(), {
      size: Mapobj.getSize(),
      padding: [100, 100, 100, 100]
    })
  }
}

function AddWKT2Source (geowkt, isZoomTo) {
  var format = new WKT()
  var feature = format.readFeature(geowkt, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:4326'
  })
  overSource.clear()
  overSource.addFeature(feature)
  var res = productReselution()
  areaIsFit(feature.getGeometry().getExtent(), res)
  updateArea(feature.getGeometry().getArea())
  if (isZoomTo) {
    Mapobj.getView().fit(feature.getGeometry().getExtent(), {
      size: Mapobj.getSize(),
      padding: [100, 100, 100, 100]
    })
  }
}

function AddWKTs2Source (geowkt, isZoomTo, type, flag) {
  var format = new WKT()
  var feature = format.readFeature(geowkt, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:4326'
  })
  // overSource.clear()
  var style = null
  if (type === 'data') {
    style = new Style({
      fill: new Fill({
        color: 'rgba(160, 32, 240, 0.5)'
      })
    })
  } else {
    style = new Style({
      stroke: new Stroke({
        color: 'red'
      })
    })
  }
  feature.setStyle(style)

  overSource.addFeature(feature)
  var res = productReselution()
  if (flag) {
    areaIsFit(feature.getGeometry().getExtent(), res)
  }
  updateArea(feature.getGeometry().getArea())
  if (type !== 'loading') {
    store.commit('setLoading', false)
  }
  if (isZoomTo) {
    Mapobj.getView().fit(feature.getGeometry().getExtent(), {
      size: Mapobj.getSize(),
      padding: [100, 100, 100, 100]
    })
  }
}

// 添加快视图
// var imageLayer = new Layer()
function AddImage (geowkt, extent, url, imageId, type) {
  var format = new WKT()
  var feature = format.readFeature(geowkt, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:4326'
  })
  if (type === 'quick') {
    var imageLayer = new Layer({
      name: imageId
    })
    var imageSource = new ImageStatic({
      url: url,
      projection: 'EPSG:3857',
      imageExtent: transformExtent(extent, 'EPSG:4326', 'EPSG:3857'),
      imageLoadFunction: (image, src) => {
        removeImgBg(url, function (imgUrl) {
          image.getImage().src = imgUrl
        })
      }
    })
    imageLayer.setSource(imageSource)
    imageLayer.setZIndex(999)
    Mapobj.addLayer(imageLayer)
    Mapobj.getView().fit(feature.getGeometry().getExtent(), {
      size: Mapobj.getSize(),
      padding: [100, 100, 100, 100]
    })
  } else {
    Mapobj.getLayers().forEach(function (layer) {
      if (layer.get('name') === imageId) {
        Mapobj.removeLayer(layer)
      }
    })
  }
}

/** 清除图片背景颜色 **/
function removeImgBg (url, callback) {
  var img = new Image()
  img.src = url
  img.onload = () => {
    // 背景颜色  黑色
    const rgba = [0, 0, 0, 0]
    // 容差大小
    const tolerance = 60
    let imgData = null
    const [r0, g0, b0] = rgba
    var r, g, b
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const w = img.width
    const h = img.height

    canvas.width = w
    canvas.height = h
    context.drawImage(img, 0, 0, w, h)
    imgData = context.getImageData(0, 0, w, h)

    for (let i = 0; i < imgData.data.length; i += 4) {
      r = imgData.data[i]
      g = imgData.data[i + 1]
      b = imgData.data[i + 2]
      const t = Math.sqrt((r - r0) ** 2 + (g - g0) ** 2 + (b - b0) ** 2)
      if (t <= tolerance) {
        imgData.data[i] = 0
        imgData.data[i + 1] = 0
        imgData.data[i + 2] = 0
        imgData.data[i + 3] = 0
      }
    }
    context.putImageData(imgData, 0, 0)
    const newBase64 = canvas.toDataURL('image/png')
    callback(newBase64)
  }
}
// 设置首页显示地图地图为img_c类型
function InitMap (map) {
  SwitchLayer('img_c')
  overVector.setZIndex(996)
  map.addLayer(overVector)
  Mapobj.getView().on('change:resolution', function () {
    mapZoom = this.getZoom()
  })
  return map
}
// 绘图 绘制几何图形 绘制多边形
var drawPolygon, drawRectangle
// 绘图方法
function RemoveInteractions (map) {
  map.removeInteraction(drawPolygon)
  map.removeInteraction(drawRectangle)
}
drawRectangle = new Draw({
  source: overSource,
  type: 'LineString',
  maxPoints: 2,
  geometryFunction: function (coordinates, geometry) {
    overSource.clear()
    var start = coordinates[0]
    var end = coordinates[1]
    if (!geometry) {
      geometry = new Polygon([
        [start, [start[0], end[1]], end, [end[0], start[1]], start]
      ])
    }
    geometry.setCoordinates([
      [start, [start[0], end[1]], end, [end[0], start[1]], start]
    ])
    updateArea(geometry.getArea())
    return geometry
  }
})
// 清除几何区域
function ClearOverSource () {
  overSource.clear()
  document.getElementById('footarea').innerHTML = ''
}
drawPolygon = new Draw({
  source: overSource,
  type: 'Polygon',
  maxPoints: 30,
  geometryFunction: function (coordinates, geometry) {
    overSource.clear()
    if (!geometry) {
      geometry = new Polygon(coordinates)
    }
    geometry.setCoordinates(coordinates)
    var coors = geometry.getCoordinates()
    coors[0].push(coors[0][0])
    geometry.setCoordinates(coors)
    updateArea(geometry.getArea())
    return geometry
  }
})
var flag = false
function GetDrawPolygonWKT (resolution) {
  var features = overSource.getFeatures()
  for (var i in features) {
    if (i === '0') {
      var f = features[i]
      var g = f.getGeometry()
      if ((g.getArea() < resolution * resolution * 4) && resolution != null) {
        context.$message({
          message: '当前所选产品最小购买范围为 ' + (resolution * resolution * 4).toFixed(6) + ' 经纬度面积',
          type: 'warning'
        })
        return
      }
      if (!areaIsFit(f.getGeometry().getExtent(), resolution)) {
        return 'little'
      }
      var format = new WKT()
      var wktstr = format.writeGeometry(g, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:4326'
      })
      return wktstr
    }
  }
  return ''
}
drawPolygon.on('drawend',
  function (e) {
    console.log(e)
    var res = productReselution()
    if (res != null) {
      var extent = e.feature.getGeometry().getExtent()
      var drawGeometry = e.feature.getGeometry()
      var format = new WKT()
      var wktstr = format.writeGeometry(drawGeometry, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:4326'
      })
      store.commit('setDrawgeometry', wktstr)
      if (!flag) {
        areaIsFit(extent, res)
      }
    }
    RemoveInteractions(Mapobj)
  }, this)
drawRectangle.on('drawend',
  function (e) {
    var res = productReselution()
    if (res != null) {
      var extent = e.feature.getGeometry().getExtent()
      var drawGeometry = e.feature.getGeometry()
      var format = new WKT()
      var wktstr = format.writeGeometry(drawGeometry, {
        dataProjection: 'EPSG:4326',
        featureProjection: 'EPSG:4326'
      })
      store.commit('setDrawgeometry', wktstr)
      if (!flag) {
        areaIsFit(extent, res)
      }
    }
    RemoveInteractions(Mapobj)
  }, this)

function AddInteractions (type, map, isData) {
  flag = isData
  RemoveInteractions(map)
  switch (type) {
    case 'rectangle':
      console.log(map)
      map.addInteraction(drawRectangle)
      break
    case 'polygon':
      map.addInteraction(drawPolygon)
      break
    case 'cancle':
      break
  }
}

function featureFlash (feature) {
  var start = new Date().getTime()
  var listenerKey = Mapobj.on('postcompose', animate)
  var duration = 700

  function animate (event) {
    var vectorContext = event.vectorContext
    var frameState = event.frameState
    var flashGeom = feature.getGeometry().clone()
    var elapsed = frameState.time - start
    var elapsedRatio = elapsed / duration
    var opacity = easeOut(1 - elapsedRatio)
    var style = new Style({
      stroke: new Stroke({
        color: 'rgba(255, ' + opacity * 255 + ',' + opacity * 255 + ', ' + (1 - opacity) + ')',
        width: opacity * 10
      })
    })
    vectorContext.setStyle(style)
    vectorContext.drawGeometry(flashGeom)
    if (elapsed > duration) {
      unByKey(listenerKey)
      return
    }
    Mapobj.render()
  }
}
overSource.on('addfeature', function (e) {
  featureFlash(e.feature)
})
var geoTiffs = []
var layersUrls = []
var singleLayerVisible = true

function GetGeoTiffsByName (name) {
  for (var i = 0; i < geoTiffs.length; i++) {
    if (geoTiffs[i].name === name) {
      return geoTiffs[i]
    }
  }
  return null
}

function RemoveGeoTiffByName (name) {
  for (var i = 0; i < geoTiffs.length; i++) {
    if (geoTiffs[i].name === name) {
      geoTiffs.splice(i, 1)
      i--
    }
  }
  return true
}

function SetLayerOpacity (layername, value) {
  try {
    var name = 'Layer' + layername
    var muiltBandLayer = GetLayerByName(name)
    if (muiltBandLayer == null) {
      return false
    } else {
      var opacity = value / 100
      muiltBandLayer.setOpacity(opacity)
      return true
    }
  } catch (err) {
    return false
  }
}

function SetLayerColor (palette, layerid) {
  var layername = 'Layer' + layerid
  var geoTiff = GetGeoTiffsByName(layername).geoTiff
  geoTiff.plotOptions.palette = palette
  geoTiff.redraw()
}

function SetLayerXrang (layername, value) {
  var name = 'Layer' + layername
  var geoTiff = GetGeoTiffsByName(name).geoTiff
  geoTiff.plotOptions.domain = [value[0], value[1] * 10]
  geoTiff.redraw()
}

function GetLayerByName (name) {
  var result = null
  Mapobj.getLayers().forEach(function (layer, i) {
    if (layer.get('name') === name) {
      result = layer
    }
  })
  return result
}

function RemoveLayerByName (layername) {
  try {
    var muiltBandLayer = GetLayerByName(layername)
    Mapobj.removeLayer(muiltBandLayer)
    try {
      RemoveGeoTiffByName(layername)
    } catch (err1) {
      console.log(err1)
    }
    removePixelShowOnMap(layername)
    return true
  } catch (err) {
    return false
  }
}

function removeMouseMoveOnMap () {
  Mapobj.removeEventListener('pointermove', function (evt) {
    console.log('sg')
    Mapobj.render()
  })
}

function removePixelShowOnMap (layerName) {
  var layersLength = 0
  Mapobj.getLayers().forEach(function (layer, i) {
    layersLength++
  })
  layersUrls.each(function (index, value) {
    if (value.name === layerName) {
      layersUrls = layersUrls.splice(index, 1)
    }
  })
  if (layersLength === 7) {
    removeMouseMoveOnMap()
  }
}

function resTooSmall (res) {
  for (var i = 0; i < res.length; i++) {
    if (res[i] < 0.001) {
      return true
    }
  }
}

function LoadSingleBandByXYZ (p) {
  if (mapZoom > 5) {
    Mapobj.getView().setZoom(5)
  }
  try {
    var name = 'Layer' + p.product_id
    var singleBandLayer = GetLayerByName(name)
    var isNotLoad = false
    var projection = getProjection('EPSG:' + p.map_projection)
    var resolutionstr = p.tile_resolution
    var rs, resolutionss, r
    if (resolutionstr != null) {
      /* eslint-disable */
      rs = resolutionstr.split(/[,\n\[\]]/)
      resolutionss = []
      for (var idx in rs) {
        var k = Number(rs[idx])
        if (k > 0) {
          resolutionss.push(k)
        }
      }
      r = '[' + resolutionss.join(',') + ']'
    }
    var resolutions = JSON.parse(r)
    var tileGrid = new TileGrid({
      resolutions: resolutions, // [0.288,0.144,0.072,0.036,0.018],
      extent: [Number(p.upper_left_long), Number(p.lower_right_lat), Number(p.lower_right_long), Number(p.upper_left_lat)], // [60.4195394397764,16.9754844327523,140.276539439776,60.3284844327523],
      tileSize: 256
    })
    if (singleBandLayer == null) {
      isNotLoad = true
      singleBandLayer = new TileLayer({
        name: name,
        source: new XYZ({
          // url: "http://localhost:8080/RemoteSensingImageCenter/data/cache/muiltband/china/{z}/{x}/{y}.png"
          crossOrigin: 'anonymous',
          url: p.tile_url + '{z}/{x}/{y}.tif',
          // url: "http://127.0.0.1:8082/tile/RJ_1842011600504_20180529/" + "{z}/{x}/{y}.tif",
          projection: projection,
          tileGrid: tileGrid,
          wrapX: true
        })
      })
    } else {
      singleBandLayer.setSource(new XYZ({ // url: "http://localhost:8080/RemoteSensingImageCenter/data/cache/muiltband/china/{z}/{x}/{y}.png"
        crossOrigin: 'anonymous',
        url: p.tile_url + '{z}/{x}/{y}.tif',
        projection: projection,
        tileGrid: tileGrid,
        wrapX: true
      }))
    }
    if (isNotLoad) {
      overVector.setZIndex(996)
      singleBandLayer.setZIndex(Mapobj.getLayers().getLength())
      if (resTooSmall(resolutions)) {
        if (Mapobj.getView().getZoom() < 10) {
          Mapobj.getView().fit([p['upper_left_long'], p['lower_right_lat'], p['lower_right_long'], p['upper_left_lat']], Mapobj.getSize())
        }
        Mapobj.getView().on('change:resolution', function () {
          mapZoom = this.getZoom()
          console.log(mapZoom)
          if (mapZoom > 10 && singleLayerVisible) {
            singleBandLayer.setVisible(true)
          } else {
            singleBandLayer.setVisible(false)
          }
        })
      }
      var layerUrl = {
        'name': name,
        'url': p.tile_url,
        'index': layersUrls.length
      }
      layersUrls.push(layerUrl)
      if (!(IEVersion() === 'ie')) {
        mouseMoveOnMap()
      }
      singleBandLayer.setZIndex(Mapobj.getLayers().getLength())
      console.log(singleBandLayer)
      Mapobj.addLayer(singleBandLayer)
    }
    return true
  } catch (e) {
    return false
  }
}

function SetLayersZIndex (layername, index) {
  var layer = GetLayerByName(layername)
  layer.setZIndex(index)
}

function LoadMuiltBandByXYZ (p) {
  try {
    var name = 'Layer' + p.product_id
    var muiltBandLayer = GetLayerByName(name)
    var isNotLoad = false
    var projection = getProjection('EPSG:' + p.map_projection)
    var resolutionstr = p.tile_resolution
    var rs, resolutionss, r
    if (resolutionstr != null) {
      rs = resolutionstr.split(/[,\n\[\]]/)
      resolutionss = []
      for (var idx in rs) {
        var k = Number(rs[idx])
        if (k > 0) {
          resolutionss.push(k)
        }
      }
      r = '[' + resolutionss.join(',') + ']'
    }
    var resolutions = JSON.parse(r)
    var tileGrid = new TileGrid({
      resolutions: resolutions,
      extent: [Number(p.upper_left_long), Number(p.lower_right_lat), Number(p.lower_right_long), Number(p.upper_left_lat)],
      tileSize: 256
    })
    if (muiltBandLayer == null) {
      isNotLoad = true
      muiltBandLayer = new TileLayer({
        name: name,
        source: new XYZ({
          crossOrigin: 'anonymous',
          url: p.tile_url + '{z}/{x}/{y}.png',
          projection: projection,
          tileGrid: tileGrid,
          wrapX: true
        })
      })
    } else {
      muiltBandLayer.setSource(new XYZ({
        crossOrigin: 'anonymous',
        url: p.tile_url + '{z}/{x}/{y}.png',
        projection: projection,
        tileGrid: tileGrid,
        wrapX: true
      }))
    }
    if (isNotLoad) {
      overVector.setZIndex(996)
      muiltBandLayer.setZIndex(Mapobj.getLayers().getLength())
      console.log(muiltBandLayer)
      Mapobj.addLayer(muiltBandLayer)
    }
    return true
  } catch (e) {
    return false
  }
}

function updateLayersUrls (productId, isInsert) {
  var it = document.getElementById('tcdong')
  var layerurl = ''
  var cs = it.childNodes
  for (var i = 0; i < cs.length; i++) {
    if (cs[i].id === productId) {
      layerurl = cs[i].getAttribute('layerurl')
    }
  }
  if (isInsert) {
    var layerUrl = {
      'name': 'Layer' + productId,
      'url': layerurl,
      'index': 0
    }
    if (layersUrls.length > 0) {
      layersUrls.forEach((el, index) => {
        if (el.name === layerUrl.name) {
          layersUrls.splice(index, 1)
        }
      })
      layerUrl.index = layersUrls.length
      layersUrls.push(layerUrl)
    } else {
      layerUrl.index = layersUrls.length
      layersUrls.push(layerUrl)
    }
    if (layersUrls.length === 1) {
      mouseMoveOnMap()
    }
  } else {
    layersUrls.forEach((value, idx) => {
      if (value.name === 'Layer' + productId) {
        layersUrls.splice(idx, 1)
      }
    })
    if (layersUrls.length === 0) {
      removeMouseMoveOnMap()
    }
  }
  console.log(layersUrls)
}

function SetLayerVisible (productId, isVisible) {
  singleLayerVisible = isVisible
  try {
    var name = 'Layer' + productId
    var muiltBaseLayer = GetLayerByName(name)
    if (muiltBaseLayer == null) {
      return false
    } else {
      muiltBaseLayer.setVisible(isVisible)
      updateLayersUrls(productId, isVisible)
      return true
    }
  } catch (err) {
    return false
  }
}

function getFireLayer (coordinates, name) {
  var features = []

  coordinates.forEach(function (value, index) {
    var feature = new Feature({
      geometry: new Point([value.longitude, value.latitude])
    })
    feature.setStyle(featureStyle(feature))
    feature.changed()
    features.push(feature)
  })

  var fireSource = new Vector({
    features: features,
    projection: 'EPSG:4326'
  })

  var fireLayer = new LayerVector({
    source: fireSource,
    name: name
  })

  function featureStyle (feature) {
    var style = new Style({
      text: new Text({
        textBaseline: 'middle',
        textAlign: 'middle',
        text: feature.get('name'),
        font: 'normal 11px 微软雅黑',
        offsetX: -15,
        offsetY: -18,
        fill: new Fill({
          color: 'red'
        })
      }),
      image: new Circle({
        radius: 5,
        fill: new Fill({
          color: 'red'
        })
      })
    })
    return style
  }
  fireLayer.setZIndex(Mapobj.getLayers().getLength())
  console.log(fireLayer)
  return fireLayer
};

function addLayerforpoint (layer) {
  Mapobj.addLayer(layer)
};

function AddRectangle2Source (top, right, bottom, left, isZoomTo) {
  var geometry = new Polygon([
    [left, top],
    [right, top],
    [right, bottom],
    [left, bottom],
    [left, top]
  ])
  geometry.setCoordinates([
    [
      [left, top],
      [right, top],
      [right, bottom],
      [left, bottom],
      [left, top]
    ]
  ])
  var feature = new Feature({
    geometry: geometry
  })
  overSource.clear()
  overSource.addFeature(feature)
  if (isZoomTo) {
    Mapobj.getView().fit(feature.getGeometry().getExtent(), Mapobj.getSize())
  }

  var format = new WKT()
  var wktstr = format.writeGeometry(geometry, {
    dataProjection: 'EPSG:4326',
    featureProjection: 'EPSG:4326'
  })
  store.commit('setDrawgeometry', wktstr)

}

function setZoomin () {
  var view = Mapobj.getView()
  view.setZoom(view.getZoom() + 1)
}

function setZoomout () {
  var view = Mapobj.getView()
  view.setZoom(view.getZoom() - 1)
}

function mouseMoveOnMap () {
  var originX = 73.5
  var originY = 53.5
  var rightBottomX = 135
  var rightBottomY = -8

  var oldCol = -1
  var oldRow = -1
  var oldLevel = -1
  var tifUrl = ''
  var raster = null
  var userAgent = navigator.userAgent
  // eslint-disable-next-line no-undef
  if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera) {
    return
  }
  let valueDiv = document.createElement('div')
  valueDiv.id = 'real_value'
  valueDiv.style.height = '16px'
  valueDiv.style.lineHeight = '16px'
  valueDiv.style.background = 'rgba(50,50,50,0.8)'
  valueDiv.style.color = 'white'
  valueDiv.style.position = 'fixed'
  valueDiv.style.fontSize = '10px'
  valueDiv.style.borderRadius = '3px'
  valueDiv.style.padding = '0 4px'
  document.getElementsByTagName('body')[0].append(valueDiv)
  Mapobj.on('pointermove', function (evt) {
    var pixel = evt.pixel
    let top = pixel[1] + 20 + 'px'
    let left = pixel[0] + 'px'
    var pdiv = document.getElementById('real_value')
    pdiv.style.top = top
    pdiv.style.left = left
    var coor = evt.coordinate
    var tileLevel = (mapZoom - 2) > 3 ? 3 : mapZoom - 2
    var longtitude = coor[1]
    var latitude = coor[0]
    var row = Math.abs(Math.floor((originX - latitude) / ((rightBottomX - originX) / Math.pow(2, tileLevel)))) - 1
    var col = Math.abs(Math.floor((originY - longtitude) / ((rightBottomY - originY) / Math.pow(2, tileLevel)))) - 1
    if (row < 0 || (row >= Math.pow(2, tileLevel)) || (col < 0) || (col >= Math.pow(2, tileLevel))) {
      row = 0
      return
    }
    if (row >= Math.pow(2, tileLevel)) {
      row = row - 1
    }
    if (col < 0) {
      row = 0
    }
    if (col >= Math.pow(2, tileLevel)) {
      row = row - 1
    }
    if ((((oldCol !== col) || (oldRow !== row)) && (col >= 0 && row >= 0)) || (oldLevel !== mapZoom)) {
      oldCol = col
      oldRow = row
      oldLevel = mapZoom
      layersUrls.forEach((item, index) => {
        if (index === layersUrls.length - 1) {
          tifUrl = item['url'] + tileLevel + '/' + row + '/' + col + '.tif'
          if (window.Promise) {
            asyncGeoblazeData(tifUrl).then(function (ras) {
              raster = ras
            })
          }
        }
      })
    }
    if (raster != null) {
      var mapBounds = Mapobj.getView().calculateExtent(Mapobj.getSize())
      var pixelSize = (mapBounds[2] - mapBounds[0]) / evt.frameState.size[0]
      var longLeft = mapBounds[0] + pixelSize * pixel[0]
      var latTop = mapBounds[3] - pixelSize * pixel[1]
      var coordinate = [longLeft + pixelSize * 0.499, latTop - pixelSize * 0.5, longLeft + pixelSize * 0.50, latTop - pixelSize * 0.499]
      geoblaze.sum(raster, coordinate).map(function (value) {
        pdiv.innerHTML = value.toFixed(2) + ''
      })
    }
  })
}

function asyncGeoblazeData (url) {
  return new Promise(function (resolve) {
    var raster = geoblaze.load(url)
    resolve(raster)
  })
}

function IEVersion () {
  var userAgent = navigator.userAgent
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    return 'ie'
  } else if (isEdge) {
    return 'edge'
  } else if (isIE11) {
    return 11
  } else {
    return -1
  }
}
export default {
  AddRectangle2Source,
  SetLayerColor,
  SetLayerXrang,
  SetLayerOpacity,
  setZoomin,
  setZoomout,
  SetLayerVisible,
  LoadMuiltBandByXYZ,
  getmap,
  SwitchLayer,
  AddWKT2Source,
  subAddWKT2Source,
  AddWKTs2Source,
  AddImage,
  InitMap,
  AddInteractions,
  RemoveInteractions,
  ClearOverSource,
  GetDrawPolygonWKT,
  GetGeoTiffsByName,
  RemoveGeoTiffByName,
  RemoveLayerByName,
  GetLayerByName,
  LoadSingleBandByXYZ,
  getFireLayer,
  addLayerforpoint,
  geoTiffs,
  SetLayersZIndex,
  Mapobj,
  changeMapCenter
}



// WEBPACK FOOTER //
// ./src/common/map/Tmap.js